import React, { forwardRef } from 'react';
import type { TextFieldProps } from '@mui/material';
import { TextField as TextFieldMUI } from '@mui/material';

import type { ShapeProp } from '@/mui/types';

import { omitUndefinedProps } from '@/mui/helpers';

import { CUSTOM_ATTRIBUTE_FILLED_TYPE, CUSTOM_ATTRIBUTE_SHAPE, CUSTOM_ATTRIBUTE_TEXT_ALIGN } from './TextField.api';

type Props = {
  shape?: ShapeProp;
  textAlign?: 'left' | 'center' | 'right';
};

const TextField = forwardRef<HTMLDivElement, TextFieldProps & Props>((props, ref) => (
  <TextFieldMUI
    {...omitUndefinedProps({
      ...props,
      size: props.size ?? 'medium',
      shape: undefined,
      textAlign: undefined,
      [CUSTOM_ATTRIBUTE_SHAPE]: props.shape,
      [CUSTOM_ATTRIBUTE_FILLED_TYPE]: props.variant === 'filled' ? '' : undefined,
      [CUSTOM_ATTRIBUTE_TEXT_ALIGN]: props.textAlign,
    })}
    variant="outlined"
    ref={ref}
  />
));

TextField.displayName = 'TextField';

export default TextField;
